export const CAPTIONS = [
  {
    text: "Feeling hootiful today",
    category: "Puns",
  }, {
    text: "I've got my eyes on hoo",
    category: "Puns",
  }, {
    text: "Everyone's hootin' at me",
    category: "Puns",
  }, {
    text: "Owl see you later",
    category: "Puns",
  }, {
    text: "Owlways late...sorry",
    category: "Puns",
  }, {
    text: "Owlways slaying the day",
    category: "Puns",
  }, {
    text: "Me, myself, and owl",
    category: "Puns",
  }, {
    text: "Owl I need is some love",
    category: "Puns",
  }, {
    text: "Owl I need is some coffee",
    category: "Puns",
  }, {
    text: "I'm a night owl",
    category: "Puns",
  }, {
    text: "I'm a know-it-owl",
    category: "Puns",
  }, {
    text: "By owl means, tell me I'm cute",
    category: "Puns",
  }, {
    text: "I'll owlways be there for you",
    category: "Puns",
  }, {
    text: "I'm a day dreamer and a night thinker",
    category: "Puns",
  }, {
    text: "Smart owleck",
    category: "Puns",
  }, {
    text: "Hooooo let the dogs out?",
    category: "Puns",
  }, {
    text: "Owl be waiting",
    category: "Puns",
  }, {
    text: "Owl-Am a reader",
    category: "Puns",
  }, {
    text: "Owlways love to learn",
    category: "Puns",
  }, {
    text: "Owl help you",
    category: "Puns",
  }, { 
    text: "How's this outfit? Yes or no?",
    category: "Non-Puns"
  }, { 
    text: "Every day I'm flipping pages",
    category: "Non-Puns"
  }, { 
    text: "'A day without laughter is a day wasted' -Charlie Chaplin",
    category: "Non-Puns"
  }, { 
    text: "Sun's shining but I'm brighter",
    category: "Non-Puns"
  }, { 
    text: "Messy hair, don't care",
    category: "Non-Puns"
  }, { 
    text: "'The only way to have a friend is to be one' -Ralph Waldo Emmerson",
    category: "Non-Puns"
  }, { 
    text: "Beach day!!!",
    category: "Non-Puns"
  }, { 
    text: "'I solemnly swear I am up to no good.' ― Harry Potter",
    category: "Non-Puns"
  }, { 
    text: "Espresso yourself",
    category: "Non-Puns"
  }, { 
    text: "See you on the Hogwarts express",
    category: "Non-Puns"
  }, { 
    text: "I see you seeing me",
    category: "Non-Puns"
  }, { 
    text: "Smiling cuz' it's summer",
    category: "Non-Puns"
  }, { 
    text: "Live, love, laugh",
    category: "Non-Puns"
  }, { 
    text: "Be love",
    category: "Non-Puns"
  }, { 
    text: "Everyday I'm hustling ",
    category: "Non-Puns"
  }, { 
    text: "Be a baguette in a box of bagels",
    category: "Non-Puns"
  }, { 
    text: "Work hard, be kind",
    category: "Non-Puns"
  }, { 
    text: "Girl from another world",
    category: "Non-Puns"
  }, { 
    text: "Boy from another world",
    category: "Non-Puns"
  }, { 
    text: "Owl from another world",
    category: "Non-Puns"
  }, { 
    text: "Be happy",
    category: "Non-Puns"
  }, { 
    text: "Smile while you still have teeth",
    category: "Non-Puns"
  }, { 
    text: "Seas the day",
    category: "Non-Puns"
  }, { 
    text: "You're snow much fun",
    category: "Non-Puns"
  }, { 
    text: "Say 'Happy Birthday' to me!",
    category: "Non-Puns"
  }, { 
    text: "Can you not?",
    category: "Non-Puns"
  }, { 
    text: "Be blessed",
    category: "Non-Puns"
  }, { 
    text: "Just beeee yourself",
    category: "Non-Puns"
  }, { 
    text: "Motivation Monday",
    category: "Non-Puns"
  }, { 
    text: "Travel Tuesday",
    category: "Non-Puns"
  }, { 
    text: "Taco Tuesday",
    category: "Non-Puns"
  }, { 
    text: "Wisdom Wednesday",
    category: "Non-Puns"
  }, { 
    text: "Fashion Friday",
    category: "Non-Puns"
  }, { 
    text: "Saturday Style",
    category: "Non-Puns"
  }, { 
    text: "Sunday Funday",
    category: "Non-Puns"
  }, { 
    text: "Sunshine mixed with a little hurricane",
    category: "Non-Puns"
  }, { 
    text: "Hi there!",
    category: "Non-Puns"
  }, { 
    text: "Struck by wanderlust",
    category: "Non-Puns"
  }, { 
    text: "Eat, sleep, travel, repeat",
    category: "Non-Puns"
  }, { 
    text: "Good friends bring you coffee",
    category: "Non-Puns"
  }, { 
    text: "Good things come to those who sleep",
    category: "Non-Puns"
  }, { 
    text: "Lovin' nature",
    category: "Non-Puns"
  }, { 
    text: "In my happy place",
    category: "Non-Puns"
  }, { 
    text: "Smiles are always trending",
    category: "Non-Puns"
  }, { 
    text: "Be unique",
    category: "Non-Puns"
  }, { 
    text: "Work hard and the rest will fall into place",
    category: "Non-Puns"
  }, { 
    text: "Enjoy the moments, for one day, they will become memories",
    category: "Non-Puns"
  }, {
    text: "#rockyourself",
    category: "Hashtag"
  }, {
    text: "#imabird",
    category: "Hashtag"
  }, {
    text: "#love",
    category: "Hashtag"
  }, {
    text: "#photooftheday",
    category: "Hashtag"
  }, {
    text: "#beautiful",
    category: "Hashtag"
  }, {
    text: "#hootiful",
    category: "Hashtag"
  }, {
    text: "#fashion",
    category: "Hashtag"
  }, {
    text: "#travel",
    category: "Hashtag"
  }, {
    text: "#summer",
    category: "Hashtag"
  }, {
    text: "#winter",
    category: "Hashtag"
  }, {
    text: "#spring",
    category: "Hashtag"
  }, {
    text: "#fall",
    category: "Hashtag"
  }, {
    text: "#beachgirl",
    category: "Hashtag"
  }, {
    text: "#beachboy",
    category: "Hashtag"
  }, {
    text: "#beachowl",
    category: "Hashtag"
  }, {
    text: "#wanderer",
    category: "Hashtag"
  }, {
    text: "#model",
    category: "Hashtag"
  }, {
    text: "#style",
    category: "Hashtag"
  }, {
    text: "#happy",
    category: "Hashtag"
  }, {
    text: "#food",
    category: "Hashtag"
  }, {
    text: "#owlsjustwannahavefun",
    category: "Hashtag"
  }, {
    text: "#owlstagood",
    category: "Hashtag"
  }, {
    text: "#selfie",
    category: "Hashtag"
  }, {
    text: "#nofilter",
    category: "Hashtag"
  }, {
    text: "#owlwaysready",
    category: "Hashtag"
  }, {
    text: "#owlsrock",
    category: "Hashtag"
  }, {
    text: "#happyplace",
    category: "Hashtag"
  }, {
    text: "#trendsetter",
    category: "Hashtag"
  }, {
    text: "#uniqueness",
    category: "Hashtag"
  }, {
    text: "#NewYork",
    category: "Hashtag"
  }, {
    text: "#London",
    category: "Hashtag"
  }, {
    text: "#Dubai",
    category: "Hashtag"
  }, {
    text: "#Switzerland",
    category: "Hashtag"
  }, {
    text: "#Iloveanimals",
    category: "Hashtag"
  }, {
    text: "#tacos",
    category: "Hashtag"
  }, {
    text: "#bookworm",
    category: "Hashtag"
  }
]



// WEBPACK FOOTER //
// ./modules/lib/games/PhotoCaptions.js